import ApiUrl from './common/apiUrl';

import { fetchPost } from '../lib/network-requests';
import { removeUserToken } from 'lib/storage';

export const userLogin = async (payload: object) => {
  const response = await fetchPost(ApiUrl.LOGIN, {
    body: JSON.stringify(payload)
  });
  return response.json().then(data => {
    return data || {};
  });
};

export const userSignUp = async (payload: object) => {
  const response = await fetchPost(ApiUrl.SIGNUP, {
    body: JSON.stringify(payload)
  });
  return response.json().then(data => {
    return data || {};
  });
};

export const userLogout = async () => {
  removeUserToken();
};
